import { z } from 'zod';

/** 모집형 4탭 카운트 — BE camelCase */
export const GetSeedingMeRecruitmentCountServiceResponseSchema = z
  .object({
    pending: z.number().nonnegative(),
    confirmed: z.number().nonnegative(),
    completed: z.number().nonnegative(),
    notSelected: z.number().nonnegative(),
  })
  .describe('GetSeedingMeRecruitmentCountServiceResponseSchema');

export type GetSeedingMeRecruitmentCountServiceResponse = z.infer<
  typeof GetSeedingMeRecruitmentCountServiceResponseSchema
>;
